<template>
    <div v-if="billInfo" class="load-section-table-wrapper">
        <div class="power-indicators-summary">
            <div class="power-indicator-item">
                <span class="indicator-label">최대수요</span>
                <span class="indicator-value">
                    {{ formatValue(getMaxNeedle) }}<span class="elec-index-unit">{{ "kW" }}</span>
                </span>
            </div>

            <div class="power-indicator-item">
                <span class="indicator-label">진상역률</span>
                <span class="indicator-value">
                    {{ formatValue(billInfo.jnPwrfact) }}<span class="elec-index-unit">{{ "%" }}</span>
                </span>
            </div>
            <div class="power-indicator-item">
                <span class="indicator-label">지상역률</span>
                <span class="indicator-value">
                    {{ formatValue(billInfo.jiPwrfact) }}<span class="elec-index-unit">{{ "%" }}</span>
                </span>
            </div>
        </div>
        <CommonTable :data="formatTableData" :columns="columns" max-height="300px" highlight-row="합계" />
    </div>
</template>

<script>
import CommonTable from "../common/CommonTable.vue";

export default {
    name: "BillLoadSectionTable",
    components: {
        CommonTable,
    },
    props: {
        billInfo: {
            type: Object,
            default: () => null,
        },
        data: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    computed: {
        getMaxNeedle() {
            if (!this.billInfo) return 0;
            // 최대수요값은 중간부하 최대수요와 최대부하 최대수요 중 큰 값
            const mload = Number(this.billInfo.mloadNeedle) || 0;
            const maxload = Number(this.billInfo.maxloadNeedle) || 0;
            return Math.max(mload, maxload);
        },

        formatTableData() {
            return this.data.map((item) => {
                if (item.loadSection === "최대부하") {
                    item.maxNeedle = this.billInfo.maxloadNeedle;
                } else if (item.loadSection === "중부하") {
                    item.maxNeedle = this.billInfo.mloadNeedle;
                } else if (item.loadSection === "경부하") {
                    item.maxNeedle = this.billInfo.lloadNeedle;
                }
                return {
                    ...item,
                };
            });
        },
        columns() {
            return [
                {
                    key: "loadSection",
                    label: "부하구간",
                    align: "center",
                },
                {
                    key: "maxNeedle",
                    label: "최대수요(kW)",
                    align: "right",
                    type: "number",
                },
                {
                    key: "usage",
                    label: "사용량(kWh)",
                    align: "right",
                    type: "number",
                },
                {
                    key: "cost",
                    label: "금액(원)",
                    align: "right",
                    type: "number",
                    cellClass: "cost-cell",
                },
                // {
                //     key: "costRatio",
                //     label: "비중(%)",
                //     align: "right",
                //     type: "number",
                //     cellClass: "ratio-cell",
                // },
            ];
        },
    },
    methods: {
        toLocaleString(value) {
            return Number(value).toLocaleString();
        },
        // 0 또는 null, undefined 인 경우에는 "-" 표시
        formatValue(value) {
            if (value === 0 || value === null || value === undefined) {
                return "-";
            }
            return Number(value).toLocaleString();
        },
    },
};
</script>

<style scoped>
.load-section-table-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* 금액 컬럼 강조 */
:deep(.cost-cell) {
    color: #1e40af;
    font-weight: 700;
}

/* 비중 컬럼 */
:deep(.ratio-cell) {
    color: #059669;
    font-weight: 600;
}

/* 전력 지표 요약 */
.power-indicators-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    gap: 8px;
}

.power-indicator-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    padding: 10px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
    border-left: 3px solid #3b82f6;
}

.power-indicator-item:hover {
    background: #f1f5f9;
    border-left: 3px solid #3b82f6;
    transform: translateY(-1px);
}

.indicator-label {
    font-size: 12px;
    font-weight: 600;
    color: #bdbdbd;
    margin-bottom: 4px;
}

.indicator-value {
    font-size: 14px;
    font-weight: 800;
    color: #1e293b;
}

.elec-index-unit {
    font-size: 11px;
    color: #616161;
    font-weight: 600;
    margin-bottom: 2px;
    letter-spacing: 0.5px;
    margin-left: 2px;
}
</style>
